import { Controller } from '@hotwired/stimulus'
import { render } from 'nunjucks'
import TabsSlider from 'tabs-slider'
import PullToRefresh from 'pulltorefreshjs'
import { Grid, html } from 'gridjs'
import { esES } from 'gridjs/l10n'

import { router } from '../router'

import { Events } from '../constants'

import {
    target,
    sendEvent,
    decodeJson,
    subscribeEvent,
    unsubscribeEvent,
    retrieveSession,
    retrieveState,
    retrieveTmp,
    updateState,
    updateTmp,
    clearTmp,
    notifier,
    setText, encodeJson
} from '../utils'

import { myNotificationsPostRequest } from '../api'

export default class extends Controller {

    static targets = [
        'container',
        'tabs',
        'total-pending',
        'total-visited',
        'total-payed',
        'pending',
        'visited',
        'payed',
    ]

    static values = {
    }

    state = {
        session: null,
        pending: [],
        visited: [],
        payed: []
    }

    instances = {
        ptr: null,
        tabs: null,
        tables: {
            pending: null,
            visited: null,
            payed: null
        }
    }

    configs = {
        tabs: {
            animate: true,
            slide: 0,
            rtl: false,
            draggable: true,
            underline: true,
            heightAnimate: true,
            duration: 500,
            easing: 'cubic-bezier(0.0, 0.0, 0.2, 1)'
        },
        tables: {
            language: esES,
            search: {
                selector: (cell) => encodeJson(cell)
            },
            fixedHeader: true,
            height: 'calc(100vh - 220px)',
            columns: [
                {
                    id: 'Notificación',
                    data: (data) => data,
                    formatter: (notification) => html(
                        render('my-notification.html', notification)
                    )
                }
            ],
            style: {
                header: {
                    'text-align': 'center'
                },
                th: {
                    display: 'none'
                }
            },
            data: []
        }
    }

    container = () => target(this, 'container')

    tabs = () => target(this, 'tabs')

    totalPending = () => target(this, 'total-pending')

    totalVisited = () => target(this, 'total-visited')

    totalPayed = () => target(this, 'total-payed')

    pending = () => target(this, 'pending')

    visited = () => target(this, 'visited')

    payed = () => target(this, 'payed')

    initialize = () => {

        this.configs.tables.language.search.placeholder = 'Buscar Notificación...'
        this.configs.tables.language.noRecordsFound = 'Ningún resultado encontrado...'

        this.instances.tabs = new TabsSlider(this.tabs(), {
            ...this.configs.tabs
        })

        this.instances.tables.pending = new Grid({
            ...this.configs.tables
        })

        this.instances.tables.pending.on('rowClick', this.pendingSelected)

        this.instances.tables.visited = new Grid({
            ...this.configs.tables,
            height: 'calc(100vh - 290px)',
            pagination: {
                limit: 10,
                buttonsCount: 0,
                resetPageOnUpdate: true,
                summary: false
            }
        })

        this.instances.tables.visited.on('rowClick', this.visitedSelected)

        this.instances.tables.payed = new Grid({
            ...this.configs.tables,
            height: 'calc(100vh - 290px)',
            pagination: {
                limit: 10,
                buttonsCount: 0,
                resetPageOnUpdate: true,
                summary: false
            }
        })

        this.instances.tables.payed.on('rowClick', this.payedSelected)

        this.renderTables()

        this.renderPtr()
    }

    connect = () => {

        this.refreshOnLogin()

        this.fixInputs()

        subscribeEvent(Events.ON_LOGIN, this.refreshOnLogin)
    }

    disconnect = () => {

        this.unfixInputs()

        unsubscribeEvent(Events.ON_LOGIN, this.refreshOnLogin)
    }

    refreshOnLogin = () => {

        retrieveSession()
            .then((session) => {

                if (! session) {

                    sendEvent(Events.SHOW_LOGIN, { message: '' })

                    return
                }

                this.state.session = session

                return retrieveState()
                    .then((state) => {

                        if (! state || ! state.pending ||
                                ! state.visited || ! state.payed) {

                            this.refresh()

                            return
                        }

                        this.state.pending = state.pending
                        this.state.visited = state.visited
                        this.state.payed = state.payed

                        this.instances.tables.pending.updateConfig({ data: this.state.pending })
                        this.instances.tables.visited.updateConfig({ data: this.state.visited })
                        this.instances.tables.payed.updateConfig({ data: this.state.payed })

                        this.renderTables(true)

                        return retrieveTmp()
                    })
                    .then((tmp) => {

                        if (! tmp || ! tmp.update) {

                            return
                        }

                        this.refresh()

                        return clearTmp()
                    })
                    .then(() => this.fixTabs())
                    .catch(() => {})
          })
          .catch(() => {

              sendEvent(Events.SHOW_LOGIN, { message: '' })
          })
    }

    refresh = () => {

        if (! this.state.session) {

            return
        }

        const params = {
            rpe: this.state.session.rpe,
            password: this.state.session.password
        }

        myNotificationsPostRequest(params)
            .then(this.onRefresh)
            .catch(this.onRefresh)
    }

    onRefresh = (response) => {

        if (response.estado) {

            const {  pendientes, visitados, terminados } = decodeJson(response.mensaje)

            this.state.pending = pendientes
            this.state.visited = visitados
            this.state.payed = terminados

            this.instances.tables.pending.updateConfig({ data: this.state.pending })
            this.instances.tables.visited.updateConfig({ data: this.state.visited })
            this.instances.tables.payed.updateConfig({ data: this.state.payed })

            this.renderTables(true)

            updateState({
                pending: this.state.pending,
                visited: this.state.visited,
                payed: this.state.payed
            })
        }
    }

    fixTabs = () => {

        setTimeout(() => this.instances.tabs.recalcStyles(), 1000)
    }

    fixInputs = () => {

        setTimeout(() => this.tabs().querySelectorAll('.gridjs-input').forEach(this.fixInput), 1000)
    }

    unfixInputs = () => {

        setTimeout(() => this.tabs().querySelectorAll('.gridjs-input').forEach(this.unfixInput), 1000)
    }

    fixInput = (input) => {

        input.addEventListener('mousedown', this.fixInputEvent)
    }

    unfixInput = (input) => {

        input.removeEventListener('mousedown', this.fixInputEvent)
    }

    fixInputEvent = (event) => {

        event.stopPropagation()
    }

    renderTables = (force = false) => {

        setText(this.totalPending(), this.state.pending.length)

        setText(this.totalVisited(), this.state.visited.length)

        setText(this.totalPayed(), this.state.payed.length)

        if (force) {

            this.instances.tables.pending.forceRender()

            this.instances.tables.visited.forceRender()

            this.instances.tables.payed.forceRender()

            return
        }

        this.instances.tables.pending.render(this.pending())

        this.instances.tables.visited.render(this.visited())

        this.instances.tables.payed.render(this.payed())
    }

    renderPtr = () => {

        this.instances.ptr = PullToRefresh.init({
            instructionsPullToRefresh: 'Desliza hacia abajo para actualizar',
            instructionsReleaseToRefresh: 'Suelta para actualizar',
            instructionsRefreshing: 'Actualizando',
            mainElement: this.container(),
            triggerElement: this.container(),
            onRefresh: this.refresh,
            shouldPullToRefresh: () => {

                switch (this.instances.tabs.currentId) {

                    case 0: return ! this.pending().querySelector('.gridjs-wrapper').scrollTop

                    case 1: return ! this.visited().querySelector('.gridjs-wrapper').scrollTop

                    case 2: return ! this.payed().querySelector('.gridjs-wrapper').scrollTop

                    default: return false
                }
            }
        })
    }

    pendingSelected = (_, { cells: [ { data } ] }) => {

        this.openSelected(data)
    }

    visitedSelected = (_, { cells: [ { data } ] }) => {

        this.openSelected(data)
    }

    payedSelected = (_, { cells: [ { data } ] }) => {

        notifier.success(`La <b>notificación ${data.notificacion}</b> ya ha sido pagada`)
    }

    openSelected = (data) => {

        updateTmp(data)
            .then(() => {

                const notification = data.notificacion

                router.navigate(`/notificacion/${notification}`, {
                    historyAPIMethod: 'replaceState'
                })
            })
            .catch(() => {})
    }
}
